import React from 'react';
import vcsLogo from './gallery_main/vcs-logo-transparent.webp';
import grscLogo from './gallery_main/grsc-logo-transparent.webp';

// This app serves two hostnames from one deployment: the main Victorian
// Cruise Society site, and its sister club GR Supra Club's subdomain. Every
// page renders identically either way except for this brand config —
// colors, logo, and the handful of copy blocks that genuinely differ.
export const BRANDS = {
  vcs: {
    id: 'vcs',
    siteName: 'Victorian Cruise Society',
    shortName: 'VCS',
    logo: vcsLogo,
    logoAlt: 'Victorian Cruise Society Logo',
    domain: 'https://victoriancruisesociety.org',
    otherDomain: 'https://grsupraclub.victoriancruisesociety.org',
    colorBg: '#091020',
    colorAccent: '#2b4d99',
    heroTitle: 'Welcome to Victorian Cruise Society',
    heroTagline: 'Driven by passion, fueled by community.',
    missionParagraphs: [
      'Founded in 2024, Victorian Cruise Society is a private community of passionate enthusiasts who enjoy and appreciate the driving experience.',
      'Our mission is to cultivate a close-knit, like-minded community built on trust, respect, integrity, community, and responsibility. Here, members connect, collaborate, and share their passion for exceptional automobiles in an environment that values exclusivity and camaraderie.',
      <>
        As the sister club of <strong>Three TRIPLE Zero</strong> and home to the <strong>GR Supra Club Victoria</strong>, we work closely with other clubs to strengthen the automotive community across Victoria.
      </>,
      "Being part of our society is about more than just the cars-it's about the passionate individuals behind them.",
    ],
    membersAreaUrl: 'https://pinkslips.app/club/victorian-cruise-society',
  },
  grsc: {
    id: 'grsc',
    siteName: 'GR Supra Club',
    shortName: 'GRSC',
    logo: grscLogo,
    logoAlt: 'GR Supra Club Logo',
    domain: 'https://grsupraclub.victoriancruisesociety.org',
    otherDomain: 'https://victoriancruisesociety.org',
    colorBg: '#521616',
    colorAccent: '#ff0000',
    heroTitle: 'Welcome to GR Supra Club',
    heroTagline: 'Driven by passion, fueled by community.',
    missionParagraphs: [
      'GR Supra Club is an affiliate club of Victorian Cruise Society, created to give GR Supra owners a dedicated community to connect, share their passion, and enjoy exclusive events and cruises. Join the movement. Tag us! #GRSupraClubVic',
    ],
    membersAreaUrl: 'https://www.facebook.com/share/g/19MPWSqHe7/?mibextid=wwXIfr',
  },
};

// Subdomain prefix match (not exact-hostname) so this also works for local/
// preview hosts like `grsupraclub.localhost`. The `?brand=` override lets
// either brand be previewed from a single dev server, where there's no real
// subdomain to detect.
export function getBrandId() {
  if (typeof window === 'undefined') return 'vcs';
  if (window.location.hostname.startsWith('grsupraclub.')) return 'grsc';
  const override = new URLSearchParams(window.location.search).get('brand');
  if (override === 'grsc' || override === 'vcs') return override;
  return 'vcs';
}

const brand = BRANDS[getBrandId()];

// The brand a "switch site" control should point at — always the one the
// visitor isn't currently on.
export const otherBrand = BRANDS[brand.id === 'vcs' ? 'grsc' : 'vcs'];

export default brand;
